import { InjectionToken } from '@angular/core';
export const APP_CONFIG = new InjectionToken('app.config');

export const endPoints = {
  host: window.location.origin,
  baseUrl: '/claims/',
  apiUrl: 'api/',
  endPointName: {
    configurationEndPoint: 'Configuration',
    validateCustomer: 'Account/ValidateCustomer',
    getClaimReasons: 'B2CProductTemplate/getProductClaimReasons',
    blockCustomer: 'Account/BlockCustomer',
    claimEndPoint: 'Claim',
    documentEndPoint: 'Documents',
    claimReasonEndPoint: 'ClaimReason',
    saveCustomerVerificationAttemptLog: 'Account/SaveCustomerVerificationAttemptLog',
    getCustomerVerificationAttemptLog: 'Account/GetCustomerVerificationAttemptLog',
    getClaimQuestionSet: 'B2CProductTemplate/GetClaimsQuestionsSet',
    getPolicyDetailsForNewClaims: 'Claim/GetPolicyDetailsForNewClaims',
    getClaimReasonDocumentTypes: 'Claim/getClaimReasonDocumentTypes',
    saveClaim: 'Claim/SaveClaimDetails',
    createSkeletalPolicy: 'Policy/CreateSkeletalPolicy',
    updateSkeletalPolicy: 'Policy/UpdateSkeletalPolicy',
    expireSkeletalPolicy: 'Policy/ExpireSkeletalPolicy',
    resumeDraftClaim: 'Claim/ResumeDraftClaim',
    getExistingDraftClaim: 'Claim/GetExistingDraftClaim',
    getPartialClaimsCount: 'Claim/GetPartialClaimsCount',
    getClaimsByCustomer: 'Claim/GetClaimsByCustomer',
    submitClaim: 'Claim/SubmitClaim',
    getClaims: 'Claim/GetClaimDetails',
    getClaimAttachments: 'Claim/GetClaimAttachments',
    setClaimPage: 'Claim/SetClaimPage',
    getMenuByProfile: 'Account/GetB2CMenuByProfile',
    getToken: 'Account/GetInitToken',
    checkToken: 'Account/ValidateToken',
    getcustomeridentifier: 'Account/GetCustomerIdentifier',
    getProductTemplates: 'B2CProductTemplate/GetProductTemplatesBySponsorId',
    getProductHideTimeLoss: 'B2CProductTemplate/GetProductClaimParametersAsync',
    getProductTemplate: 'B2CProductTemplate/getProductTemplate',
    getClaimsDetailsByCustomer: 'Claim/GetClaimsByCustomer',
  }
};

export const AppConfig = {
  apiUrl: 'api/',
  configApiEndPoints: {
    GetConfigurationUrl: endPoints.apiUrl + endPoints.endPointName.configurationEndPoint + '/get'
  },
  assetsImagesPath: '/assets/images/'
};

